module.exports = __webpack_public_path__ + "static/media/glucare-big-logo.97715a9d.png";